import { Component, ReactNode, createRef } from "react"

import AutoCompleteInput from "../../libs/ui/inputs/AutoCompleteInput"
import Input from "../../libs/ui/inputs/Input"
import Select from "../../libs/ui/inputs/Select"

import { COMUNI_SEARCH_URL, CAP_SEARCH_URL } from "../../costants"

import { isEmpty } from "../../libs/validation/stringRegex"

import { authFetch } from "../../libs/cookie/Cookie"

import { STREET_NAME_PATTERN, STREET_NUMBER_PATTERN } from "../../libs/validation/stringRegex"

interface ManualSelectionProps {
    street: string | undefined
    number: string | undefined
    zip: string | undefined
    city: string | undefined

    streetError: string | undefined
    numberError: string | undefined
    zipError: string | undefined
    cityError: string | undefined
    error?: string | undefined

    updateStreet: Function
    updateNumber: Function
    updateZip: Function
    updateCity: Function

    clearStreetError?: Function
    clearNumberError?: Function
    clearZipError?: Function
    clearCityError?: Function

    expiredSessionCallbak?: Function

    isSedeLegale?: boolean | undefined
}

interface ManualSelectionState {
    showZip: boolean
    matchesZip: any[]
}

class ManualSelectionAddress extends Component<ManualSelectionProps,ManualSelectionState> {
    private comuneInput: React.RefObject<HTMLInputElement>
    private viaInput: React.RefObject<HTMLInputElement>
    private civicoInput: React.RefObject<HTMLInputElement>

    constructor (props: any) {
        super(props)

        this.state = {
            showZip: false,
            matchesZip: []
        }

        this.updateZipMatches = this.updateZipMatches.bind(this)
        this.updateCityAndZip = this.updateCityAndZip.bind(this)
        this.clearComuneError = this.clearComuneError.bind(this)
        this.clearIndirizzoError = this.clearIndirizzoError.bind(this)
        this.clarCivicoError = this.clarCivicoError.bind(this)
        this.getComuneResidenzaRequestBody = this.getComuneResidenzaRequestBody.bind(this)
        this.expiredSession = this.expiredSession.bind(this)

        this.comuneInput = createRef()
        this.viaInput = createRef()
        this.civicoInput = createRef()
    }

    componentDidMount(): void {
        // al primo caricamento del component carico la lista dei possibili "cap"
        if (
            this.props.city !== undefined && this.props.cityError === undefined &&
            this.props.zip !== undefined && this.props.zipError === undefined 
        ) {
            this.updateZipMatches( this.props.city )
        }
    }

    componentDidUpdate(prevProps: Readonly<ManualSelectionProps>, prevState: Readonly<ManualSelectionState>, snapshot?: any): void {
        // quando il component si aggiorna refresho la lista dei possibili cap
        if (
            (prevProps.city !== this.props.city || prevProps.zip !== this.props.zip) &&
            this.props.city !== undefined && this.props.cityError === undefined &&
            this.props.zip !== undefined && this.props.zipError === undefined 
        ) {
            this.updateZipMatches( this.props.city )
        }


        if (
            !isEmpty(prevProps.streetError) && prevProps.streetError !== this.props.streetError && !isEmpty(this.props.street)
        ) {
            this.viaInput.current?.focus()
        }
        if (
            !isEmpty(prevProps.numberError) && prevProps.numberError !== this.props.numberError && !isEmpty(this.props.number)
        ) {
            this.civicoInput.current?.focus()
        }
        if (
            !isEmpty(prevProps.cityError) && prevProps.cityError !== this.props.cityError && !isEmpty(this.props.city)
        ) {
            this.comuneInput.current?.focus()
        }

    }

    render(): ReactNode {
        const comuneClassName = this.state.showZip ? 'col-12 col-lg-9' : 'col-12'
        const zipClassName = this.state.showZip ? 'col-12 col-lg-3' : ''

        const id_comune = (this.props.isSedeLegale === true)
            ? 'comune_sede_legale'
            : 'comune_residenza'

        const label_comune = (this.props.isSedeLegale === true)
            ? 'Comune sede legale'
            : 'Comune residenza'

        const id_cap = (this.props.isSedeLegale === true)
            ? 'cap_sede_legale'
            : 'cap_residenza'

        const id_via = (this.props.isSedeLegale === true)
            ? 'via_sede_legale'
            : 'via_residenza'

        const label_via = (this.props.isSedeLegale === true)
            ? 'Indirizzo sede legale'
            : 'Indirizzo residenza'

        const id_civico = (this.props.isSedeLegale === true)
            ? 'civico_sede_legale'
            : 'civico_residenza'

        const showZip = this.state.showZip && this.state.matchesZip !== undefined && this.state.matchesZip.length > 0

        const cityError = this.props.cityError !== undefined ? 'Comune non valido' : undefined
        const capError = (this.props.zipError !== undefined && showZip) ? 'CAP non valido' : undefined
        const streetError = this.props.streetError !== undefined ? 'Indirizzo non valido' : undefined
        const numberError = this.props.numberError !== undefined ? 'Civico non valido' : undefined

        const streetClass = (numberError === undefined) ? 'col-12 col-lg-9' : 'col-12'
        const numberClass = (numberError === undefined) ? 'col-12 col-lg-3' : 'col-12'

        return (
            <div className="col-12">

                <div className="row">
                    <div className={comuneClassName}>
                        <div className="row">
                            <AutoCompleteInput 
                                id={id_comune} name={id_comune}
                                label={label_comune}
                                value={this.props.city}
                                choices={[]}
                                callback={this.updateCityAndZip}
                                updateChoicesUrl={COMUNI_SEARCH_URL}
                                error={cityError}
                                getRequstBody={this.getComuneResidenzaRequestBody}
                                expiredSessionCallbak={this.expiredSession}
                                onFocus={this.clearComuneError}

                                refInput={this.comuneInput}
                            />
                        </div>
                    </div>
                    { showZip &&
                        <div className={zipClassName}>
                            <Select
                                id={id_cap} name={id_cap}
                                label='CAP' 
                                value={this.props.zip}
                                options={this.state.matchesZip}
                                callback={this.props.updateZip}
                                error={capError}
                            />
                        </div>
                    }

                    <div className={streetClass}>
                        <Input 
                            id={id_via} name={id_via}
                            label={label_via}
                            value={this.props.street}
                            type='text'
                            maxLength={100}
                            callback={this.props.updateStreet}
                            regexp={STREET_NAME_PATTERN}
                            error={streetError}
                            onFocus={this.clearIndirizzoError}
                            onInput={(e: any) => e.currentTarget.value = (e.currentTarget.value ?? '').toUpperCase()}
                            autoComplete='off'

                            refInput={this.viaInput}
                        />
                    </div>

                    <div className={numberClass}>
                        <Input 
                            id={id_civico} name={id_civico}
                            label='Civico' 
                            value={this.props.number}
                            type='text'
                            maxLength={100}
                            callback={this.props.updateNumber}
                            regexp={STREET_NUMBER_PATTERN}
                            error={numberError}
                            onFocus={this.clarCivicoError}
                            autoComplete='off'

                            refInput={this.civicoInput}
                        />
                    </div>
                </div>

            </div>
        )
    }

    private updateZipMatches (city : string) {
        const tmp = city.split("(")

        const requestBody = {
            comune: (tmp[0].trim()).toUpperCase(),
            provincia: (tmp[1].trim()).replace(")", "")
        }
        
        authFetch (
            CAP_SEARCH_URL,
            {
                method: 'post',
                body: JSON.stringify( requestBody )
            },
            this.expiredSession
        )
        .then ((res: any[]) => {
            this.setState({
                matchesZip: res,
                showZip: (res.length > 1)
            })
        })
    }

    private updateCityAndZip (city: string | undefined) {
        if (city !== undefined && city !== '') {
            const tmp = city.split("(")

            const requestBody = {
                comune: (tmp[0].trim()).toUpperCase(),
                provincia: (tmp[1].trim()).replace(")", "")
            }

            authFetch (
                CAP_SEARCH_URL,
                {
                    method: 'post',
                    body: JSON.stringify( requestBody )
                },
                this.expiredSession
            )
            .then ((res: any[]) => {
                // res = [{"id":"20123","value":"20123"}]
                const multipleZip = (res.length > 1)

                this.setState({
                    matchesZip: res,
                    showZip: multipleZip
                }, () => {
                    this.props.updateCity (city)
                    this.props.updateZip(
                        (!multipleZip)
                            ? res[0].id
                            : undefined
                    )
                    
                })
            })
            .catch( (err) => {
                this.setState({
                    matchesZip: [],
                    showZip: false
                }, () => {
                    this.props.updateCity (city)
                    this.props.updateZip(undefined)
                })
            })

        } 
        else {
            this.props.updateCity (city)
            this.props.updateZip(undefined)
        }
        
    }

    private clearComuneError () {
        if (this.props.clearCityError) {
            this.props.clearCityError()
        }
    }

    private clearIndirizzoError () {
        if (this.props.clearStreetError) {
            this.props.clearStreetError()
        }
    }

    private clarCivicoError () {
        if (this.props.clearNumberError) {
            this.props.clearNumberError()
        }
    }

    private getComuneResidenzaRequestBody (search: string | undefined) {
        return {
            nome: search,
            isResidenza: true
        }
    }

    private expiredSession () {
        if (this.props.expiredSessionCallbak) {
            this.props.expiredSessionCallbak()
        }
    }
}

export default ManualSelectionAddress